// TEMPORARY: Market -> allowed Brands mapping (source: Consolidated_Brand_Market_List.xlsx, sheet 'Brand Market List').
// Used to filter the left-panel brand list by the selected market in Snapshot and Brand Analysis.
// Keys must match the market MetricOption name; values must match the brand Level2_value from the API.
export const MARKET_BRAND_MAP: { [market: string]: string[] } = {
  'Australia': [
    'Absolut',
    'Aperol',
    'Bacardi',
    'Baileys',
    'Bundaberg (or Bundy)',
    'Bundaberg Gold',
    'Bundaberg Up Rum',
    'Canadian Club',
    'Canadian Club Premix (any flavour)',
    'Captain Morgan',
    'Chambord',
    'Chivas Regal',
    'Diplomático',
    'el Jimador',
    'Espolon',
    'Fireball',
    'Gentleman Jack',
    'Gentleman Jack Premix',
    'Glenfiddich',
    'Gordon\'s',
    'Grey Goose',
    'Herradura',
    'Jack Daniel\'s American Serve (any flavour)',
    'Jack Daniel\'s Double Jack Premix',
    'Jack Daniel\'s Premix',
    'Jack Daniel\'s Bonded',
    'Jack Daniel\'s Seltzer',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Honey',
    'Jack Daniel\'s Apple',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jameson',
    'Jameson Premix',
    'Jim Beam',
    'Jim Beam Black Double Serve',
    'Jim Beam White Premix (any flavour)',
    'Jim Beam Premix',
    'Johnnie Walker Highball',
    'Johnnie Walker Black Label',
    'Johnnie Walker Red Label',
    'Jose Cuervo Especial',
    'Maker\'s Mark',
    'Old Forester',
    'Olmeca Altos',
    'Part Time Rangers',
    'Patrón',
    'Smirnoff Red',
    'Smirnoff Seltzer',
    'White Claw',
    'Wild Turkey',
    'Wild Turkey 101 Premix',
    'Wild Turkey Longbranch',
    'Wild Turkey American Honey',
    'Wild Turkey Traditional (any flavour)',
    'Wild Turkey Premix',
    'Woodford Reserve',
  ],
  'Canada': [
    '1800',
    'Absolut',
    'Bacardi',
    'Baileys',
    'Basil Hayden\'s',
    'Bombay Sapphire',
    'Buffalo Trace',
    'Bulleit',
    'Bumbu',
    'Canadian Club',
    'Captain Morgan Spiced',
    'Cazadores',
    'Chivas Regal',
    'Crown Royal',
    'Diplomático',
    'Don Julio',
    'Elijah Craig',
    'el Jimador',
    'Espolon',
    'Finlandia',
    'Fireball',
    'Ford\'s',
    'Forty Creek',
    'Grey Goose',
    'Hendrick\'s Gin',
    'Herradura',
    'JP Wisers',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Apple',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jägermeister',
    'Jameson',
    'Jim Beam White',
    'Jim Beam Black',
    'Jim Beam Red Stag',
    'Johnnie Walker Black Label',
    'Jose Cuervo Especial',
    'Knob Creek',
    'Maker\'s Mark',
    'Old Forester',
    'Patrón',
    'Hornitos',
    'Skyy',
    'Smirnoff',
    'Stolichnaya',
    'Wild Turkey',
    'Wild Turkey 101',
    'Wiser\'s Deluxe',
    'Woodford Reserve',
  ],
  'Chile': [
    '1800 Reposado',
    'Alto del Carmen',
    'Alto del Carmen Ice (Altonic)',
    'Aperol',
    'Bacardi',
    'Bacardi Classic Cocktail',
    'Ballantine\'s',
    'Bombay Sapphire',
    'Buchanan\'s 12',
    'Bulleit',
    'CaspelIce',
    'Chivas Extra',
    'Chivas Regal',
    'Chivas Regal 18',
    'Don Julio Blanco',
    'Don Julio Reposado',
    'el Jimador Reposado',
    'El Jimador Blanco',
    'Eristoff Black',
    'Finlandia',
    'Gentleman Jack',
    'Herradura Añejo',
    'Herradura Reposado',
    'Hendrick\'s',
    'Jack Daniel\'s & Cola',
    'Jack Daniel\'s & Coca Cola',
    'Jack Daniel\'s & Ginger',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Blackberry',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jägermeister',
    'Jameson',
    'Jim Beam',
    'Johnnie Walker Black Label',
    'Johnnie Walker Blue Label',
    'Johnnie Walker Blonde',
    'Johnnie Walker Double Black',
    'Johnnie Walker Red Label',
    'Jose Cuervo',
    'Jose Cuervo Especial Silver',
    'Mistral',
    'Mistral Apple',
    'Mistral Ice',
    'Old Parr',
    'Olmeca Blanco',
    'Ramazotti Rosato',
    'Sierra Morena',
    'Smirnoff Ice',
    'Spirit Cocktail',
  ],
  'France': [
    'Aberlour',
    'Absolut',
    'Aperol',
    'Ballantine\'s',
    'BenRiach',
    'Bumbu',
    'Captain Morgan Spiced',
    'Cardhu',
    'Chivas Regal',
    'Clan Campbell',
    'Clement VO',
    'Don Papa',
    'Diplomático',
    'Four Roses',
    'Gentleman Jack',
    'Get 27',
    'Gibson\'s',
    'Gin Mare',
    'Glenfiddich',
    'Grant\'s',
    'Havana Club',
    'J&B',
    'Jack Daniel\'s Bonded',
    'Jack Daniel\'s & Cola',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Blackberry',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Rye',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jägermeister',
    'Jameson',
    'Jim Beam',
    'Johnnie Walker (red pk)',
    'Johnnie Walker Black',
    'Monkey Shoulder',
    'Nikka',
    'Plantation Original Dark (Double Aged)',
    'Planteray',
    'Poliakov',
    'Ricard',
    'Smirnoff Ice',
    'Talisker',
    'William Peel',
    'Woodford Reserve',
  ],
  'Germany': [
    'Absolut',
    'Aperol',
    'Aperol Spritz',
    'Bacardi',
    'Bacardi & Cola',
    'Baileys',
    'Ballantines',
    'Balvenie',
    'BenRiach',
    'Bombay Sapphire',
    'Bombay & Tonic',
    'Botucal (Diplomatico)',
    'Captain Morgan Spiced',
    'Chivas Regal',
    'Don Papa',
    'Effect Energy & Vodka',
    'Espolon',
    'Ford\'s',
    'Gentleman Jack',
    'Gin Mare',
    'Glendronach',
    'Glenfiddich',
    'Glenmorangie',
    'Gorbatshow',
    'Gordon\'s Gin & Tonic',
    'Havana Club',
    'Hendrick\'s',
    'Jack Daniel\'s & Berry',
    'Jack Daniel\'s & Cola',
    'Jack Daniel\'s & Coca Cola',
    'Jack Daniel\'s & Lynchburg Lemonade',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jägermeister',
    'Jameson',
    'Jim Beam',
    'Jim Beam & Cola',
    'Jim Beam Apple',
    'Jim Beam Honey',
    'Johnnie Walker Black Label',
    'Johnnie Walker Red Label',
    'Laphroaig',
    'Lillet',
    'Maker\'s Mark',
    'The Macallan',
    'Monkey 47',
    'Malfy',
    'Slane',
    'Southern Comfort',
    'Tullamore Dew',
    'Woodford Reserve',
  ],
  'Mexico': [
    '1800',
    '1800 Cristalino',
    'Absolut',
    'Antiguo Herradura',
    'Antiguo Herradura Cristalino',
    'Bacardi',
    'Black & White',
    'Boone\'s',
    'Buchanan\'s',
    'Caribe Cooler',
    'Chivas Regal 12',
    'Don Julio',
    'Don Julio Blanco',
    'Don Julio Reposado',
    'Don Julio 70',
    'el Jimador',
    'el Jimador Blanco',
    'el Jimador Reposado',
    'el Jimador Cristalino',
    'el Jimador Seltzer',
    'Gran Centenario',
    'Gran Centenario Plata',
    'Gran Centenario Reposado',
    'Gran Centenario Ultra',
    'Grant\'s',
    'Herradura',
    'Herradura Cristal',
    'Herradura Plata',
    'Herradura Reposado',
    'Herradura Ultra',
    'Jack Daniel\'s Ready-to-Drink Beverages',
    'Jack Daniel\'s and Ginger',
    'Jack Daniel\'s and Coca Cola',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Honey & Lemonade',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jim Beam',
    'Johnnie Walker Black Label',
    'Johnnie Walker Red Label',
    'Jose Cuervo Especial',
    'Jose Cuervo Tradicional',
    'Jose Cuervo TradicionalCristalino',
    'Maestro Dobel Diamante',
    'Michelob Ultra Seltzer',
    'New Mix',
    'Patrón',
    'Rancho Cane',
    'Hornitos',
    'Skyy Ready-to-Drink',
    'Smirnoff Tamarindo',
    'Strongbow Gold',
    'Topo Chico Paloma',
    'Torres 10',
    'ViñaReal',
  ],
  'Poland': [
    'Absolut',
    'Amundsen',
    'Aperol',
    'Auchentoshan',
    'Bacardi',
    'Ballantine\'s',
    'Ballantine\'s Brasil',
    'BenRiach',
    'Biały Bocian',
    'Bombay Sapphire',
    'Bulleit',
    'Chivas Regal',
    'Finlandia',
    'Finlandia Botanical',
    'Finlandia Flavors',
    'Gentleman Jack',
    'Glendronach',
    'Glenfiddich',
    'Glenlivet',
    'Glenmorangie',
    'Grant\'s',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Blackberry',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jack Daniel\'s & Coca Cola',
    'Jägermeister',
    'Jameson',
    'Jim Beam',
    'Jim Beam & Cola',
    'Jim Beam Stag',
    'Johnnie Walker Black Label',
    'Johnnie Walker Red Label',
    'The Macallan',
    'Nemiroff',
    'Ostoya',
    'The Singleton',
    'Soplica',
    'Stock',
    'Stumbras',
    'Tanqueray',
    'Woodford Reserve',
    'Wyborowa',
    'ŻubrówkaCzarna',
  ],
  'Russia': [
    'Absolut',
    'Absolut Flavors',
    'Auchentoshan',
    'Ballantine\'s',
    'Ballantine\'s Brasil',
    'Beluga',
    'Beluga Hunting',
    'BenRiach',
    'Chivas Regal',
    'Dewar\'s',
    'FamouseGrouse',
    'Finlandia',
    'Finlandia Flavors',
    'Gentleman Jack',
    'Glenfiddich',
    'Glenmorangie',
    'Grey Goose',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jameson',
    'Jim Beam',
    'Jim Beam Apple',
    'Jim Beam Honey',
    'Jim Beam Red Stag',
    'Johnnie Walker Black Label',
    'Johnnie Walker Red Label',
    'Maker\'s Mark',
    'Russian Standard',
    'The Macallan',
    'The Singleton',
    'Tsarskaya',
    'William Lawson\'s',
    'Woodford Reserve',
  ],
  'Spain': [
    'Absolut',
    'Aperol',
    'Bacardi',
    'Bacardi Breezer',
    'Baileys',
    'Ballantine\'s',
    'Barceló',
    'Beefeater',
    'Bombay Sapphire',
    'Bulldog',
    'Bulleit',
    'Brugal',
    'Cardhu',
    'Chivas Regal',
    'Cuervo Margarita',
    'Diplomatico Reserva Excl.',
    'Don Papa',
    'DYC 5 Yr',
    'el Jimador',
    'Gentleman Jack',
    'Gin Mare',
    'Gordon\'s Gin & Tonic',
    'G\'Vine',
    'Havana Club',
    'Hendrick\'s',
    'Herradura',
    'J&B',
    'Jack Daniel\'s & Cola',
    'Jack Daniel\'s & Coca-Cola',
    'Jack Daniel\'s & Lynchburg Lemonade',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Blackberry',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Honey & Lemonade',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jägermeister',
    'Jameson',
    'Jim Beam',
    'Johnnie Walker Black Label',
    'Johnnie Walker Red Label',
    'Larios',
    'Nordés',
    'Puerto de Indias',
    'Puerto de Indias Strawberry',
    'Roku',
    'Ruavieja Licor',
    'Seagram\'s',
    'Smirnoff Ice',
    'Tanqueray',
    'Tanqueray London Dry Gin & Tonic',
    'Woodford Reserve',
    'Zacapa Rum',
  ],
  'UK': [
    'Absolut',
    'Aperol',
    'Bacardi',
    'Baileys',
    'Balvenie',
    'BenRiach',
    'Bombay Sapphire',
    'Buffalo Trace',
    'Bulleit',
    'Captain Morgan Spiced',
    'Captain Morgan Spiced & Cola',
    'Chambord',
    'Cointreau',
    'Diplomático',
    'el Jimador',
    'Famous Grouse',
    'Finlandia',
    'Gentleman Jack',
    'Glenfiddich',
    'Gordon\'s',
    'Gordon\'s Pink',
    'Gordon\'s Pink & Tonic',
    'Haig Club Clubman',
    'Hendrick\'s',
    'Herradura',
    'Jack Daniel\'s Bonded',
    'Jack Daniel\'s & Cola',
    'Jack Daniel\'s & Coca Cola',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Blackberry',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Honey & Lemonade',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jameson',
    'Jim Beam',
    'Johnnie Walker Black Label',
    'Jose Cuervo',
    'Maker\'s Mark',
    'Monkey Shoulder',
    'Olmeca Altos',
    'Patrón',
    'Slane',
    'Smirnoff',
    'Southern Comfort',
    'Woodford Reserve',
  ],
  'US': [
    '1800',
    'Absolut',
    'Bacardi',
    'Buchanan\'s',
    'Buffalo Trace',
    'Bulleit',
    'Captain Morgan Spiced',
    'Casamigos',
    'Chambord',
    'Cointreau',
    'Crown Royal',
    'Crown Royal Blackberry',
    'Crown Royal Peach',
    'Crown Royal Regal Apple',
    'Don Julio',
    'el Jimador',
    'Elijah Craig',
    'Espolon',
    'Finlandia',
    'Fireball',
    'Gentleman Jack',
    'Hennessey VS',
    'Hendrick\'s',
    'Herradura',
    'Jack Daniel\'s Bonded',
    'Jack Daniel\'s Single Barrel',
    'Jack Daniel\'s Tennessee Apple',
    'Jack Daniel\'s Tennessee Blackberry',
    'Jack Daniel\'s Tennessee Fire',
    'Jack Daniel\'s Tennessee Honey',
    'Jack Daniel\'s Tennessee Rye',
    'Jack Daniel\'s Tennessee Whiskey',
    'Jameson',
    'Jim Beam',
    'Jose Cuervo Especial',
    'Knob Creek',
    'Lalo',
    'Lunazul',
    'Maker\'s Mark',
    'Old Forester',
    'Patrón',
    'Smirnoff',
    'St. Germain',
    'Tito\'s',
    'Uncle Nearest',
    'Woodford Reserve',
    'Woodford Reserve Double Oaked',
  ],
};

